export const toastOptionProps = {
  position: 'top-center',
  reverseOrder: true,
  containerClassName: 'message',
};
